import { gql } from '@apollo/client';

import {
  QuickDeploy__UpdateSendCookiesMutation,
  QuickDeploy__UpdateSendCookiesMutationVariables,
  QuickDeploy__UpdateSharedHeadersMutation,
  QuickDeploy__UpdateSharedHeadersMutationVariables,
  QuickDeploy__UpdateVariantURLMutation,
  QuickDeploy__UpdateVariantURLMutationVariables,
} from 'src/lib/graphqlTypes/types';

/**
 * Shared GraphQL mutations for Quick Deploy functionality
 */

/**
 * Updates the URL and subscription URL for a graph variant (Quick Deploy version)
 */
export const UpdateVariantURLMutation = gql<
  QuickDeploy__UpdateVariantURLMutation,
  QuickDeploy__UpdateVariantURLMutationVariables
>`
  mutation QuickDeploy__UpdateVariantURLMutation(
    $graph: ID!
    $variant: String!
    $url: String
    $subscriptionUrl: String
  ) {
    service(id: $graph) {
      variant(name: $variant) {
        updateURL(url: $url) {
          id
          url
        }
        updateSubscriptionURL(subscriptionUrl: $subscriptionUrl) {
          id
          subscriptionUrl
        }
      }
    }
  }
`;

/**
 * Updates the sendCookies setting for a graph variant (Quick Deploy version)
 */
export const UpdateSendCookiesMutation = gql<
  QuickDeploy__UpdateSendCookiesMutation,
  QuickDeploy__UpdateSendCookiesMutationVariables
>`
  mutation QuickDeploy__UpdateSendCookiesMutation(
    $graph: ID!
    $variant: String!
    $sendCookies: Boolean!
  ) {
    service(id: $graph) {
      variant(name: $variant) {
        updateSendCookies(sendCookies: $sendCookies) {
          id
          sendCookies
        }
      }
    }
  }
`;

/**
 * Updates shared headers for a graph variant (Quick Deploy version)
 */
export const UpdateSharedHeadersMutation = gql<
  QuickDeploy__UpdateSharedHeadersMutation,
  QuickDeploy__UpdateSharedHeadersMutationVariables
>`
  mutation QuickDeploy__UpdateSharedHeadersMutation(
    $graph: ID!
    $variant: String!
    $sharedHeaders: String
  ) {
    service(id: $graph) {
      variant(name: $variant) {
        updateSharedHeaders(sharedHeaders: $sharedHeaders) {
          id
          sharedHeaders
        }
      }
    }
  }
`;
